export const Importing = `import Dragger from "draggerjs"`
export const GettingStarted = {
html: `<div className="drag-container" id="drag-getting-started">  
    <div className="drag-around n-border-color">
        <div className="draggable-box center n-flat">
            <h1>Drag Me</h1>
        </div> 
    </div>
</div>`,
css: `.drag-container {  
    display: flex;
    flex-wrap: wrap;
    height: 250px;  
    position: relative;
}
.drag-container > .drag-around {
    flex: 1 1;
    width: 100%; 
    border: 2px dashed #fff;
    border-radius: 15px;
    padding: 15px;
    transition: box-shadow 300ms ease-in;
}
.drag-container .draggable-box {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 50px;
    min-height: 50px;
    padding: 0 10px; 
    border-radius: 10px;
    transition: box-shadow 300ms ease-in;
    cursor: grab;
}
.drag-container .draggable-box > h1 { 
    margin-bottom: 5px;
}
.drag-container .grabbed {
    cursor: grabbing;
    margin: 0;
}
.draggable-box.center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}`,
js: `const dragger = new Dragger('#drag-getting-started', {
    draggable: '.draggable-box'
})
dragger.on('dragstart', (e) => { 
    const target = e.target
    if(e.isDraggableElement) {
        // prevent mobile from scrolling
        // when dragging draggable element
        e.preventDefault()
        target.classList.add('grabbed')
        if(target.classList.contains('center')) {
            target.classList.remove('center')
        }
    }
})
dragger.on('dragend', (e) => {
    if(e.isDraggableElement) {  
        e.target.classList.remove('grabbed') 
    }
})`
}
export const Autoscroll = {
html: `<div className="drag-container drag-long-ground" id="drag-autoscroll">  
    <div className="drag-around n-border-color">
        <div className="draggable-box center n-flat">
            <h1>Drag Me</h1>
        </div> 
    </div>
</div>`,
css: `.drag-container {  
    display: flex;
    flex-wrap: wrap;
    height: 250px;  
    position: relative;
}
.drag-long-ground {
    display: block;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
}
.drag-long-ground > .drag-around {
    width: 1250px;
    height: 1250px;
}
.drag-container > .drag-around {
    flex: 1 1;
    width: 100%; 
    border: 2px dashed #fff;
    border-radius: 15px;
    padding: 15px;
    transition: box-shadow 300ms ease-in;
}
.drag-container .draggable-box {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 50px;
    min-height: 50px;
    padding: 0 10px; 
    border-radius: 10px;
    transition: box-shadow 300ms ease-in;
    cursor: grab;
}
.drag-container .draggable-box > h1 { 
    margin-bottom: 5px;
}
.drag-container .grabbed {
    cursor: grabbing;
    margin: 0;
}
.draggable-box.center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}`,
js: `const dragger = new Dragger('#drag-autoscroll', {
    draggable: '.draggable-box',
    autoscroll: true
})
dragger.on('dragstart', (e) => { 
    const target = e.target
    if(e.isDraggableElement) {
        // prevent mobile from scrolling
        // when dragging draggable element
        e.preventDefault()
        target.classList.add('grabbed')
        if(target.classList.contains('center')) {
            target.classList.remove('center')
        }
    }
})
dragger.on('dragend', (e) => {
    if(e.isDraggableElement) {  
        e.target.classList.remove('grabbed') 
    }
})`
}
export const RawDrag = {
html: `<div className="drag-drawer" id="drag-raw-drag">  
<div className="drag-drawer-content n-no-shadow n-engrave"> 
    <nav className="n-nav n-nav-flat n-nav-column">
        <a className="n-nav-link" href="#">link-1</a>
        <a className="n-nav-link" href="#">link-2</a>
        <a className="n-nav-link" href="#">link-3</a>
    </nav> 
</div>
</div>`,
css: `.drag-drawer {
    display: block;
    position: relative;
    height: 250px;
    border: 1px solid #dcdcdc;
    overflow: hidden;
}
.drag-drawer-content {
    display: block;
    position: absolute;
    top: 0;
    left: -250px;
    width: 250px;
    height: 100%;
    padding: 20px 25px;
}
.drag-drawer-content:before {
    content: "\\3009";
    display: block;
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    padding: 15px 10px;
    font-size: 30px;
    transition: opacity 300ms ease-in-out;
}
.drag-drawer-content.draw-full:before {
    opacity: 0;
}
.drag-drawer-content.draw-full:after {
    content: "";
    display: block;
    position: absolute;
    left: 100%;
    top: 0;
    width: 100%;
    height: 100%; 
}
.draw-transition {
    transition: left 300ms ease-in-out;
}
.draw-full {
    left: 0;
}`,
js: `let cleanUp
let isComplete = false 
const target = document.querySelector('.drag-drawer-content')
const dragger = new Dragger('#drag-raw-drag')
dragger.on('dragstart', (e) => { 
    if(target === e.target) {
        if(e.target.nodeName !== 'A') {
            e.preventDefault()
        }
        target.style.left = (isComplete ? 0 : -target.clientWidth) + 'px'
        target.classList.remove('draw-transition')  
        clearTimeout(cleanUp)
    }
})
dragger.on('dragmove', (e) => {    
    if(target === e.target) {
        const width = target.clientWidth  
        const distance = (isComplete ? e.moveX - e.startX : (e.moveX - e.startX) - width)
        target.style.left = (0 > distance ? -width > distance ? -width : distance : 0) + 'px' 
    }
}) 
dragger.on('dragend', (e) => { 
    if(target === e.target) {
        const width = target.clientWidth 
        const distance = isComplete ? (e.endX - e.startX) + width :  e.endX - e.startX 
        if(distance > target.clientWidth/2) {
            target.classList.add('draw-full')
            isComplete = true
        } else {  
            target.classList.remove('draw-full') 
            isComplete = false
        }
        target.style.left = null
        target.classList.add('draw-transition') 
        cleanUp = setTimeout(() => {
            target.classList.remove('draw-transition')
        }, 300) 
    }
})`
}
export const Droppable = {
html: `<div className="drag-container" id="drag-droppable">  
    <div className="droppable-area n-no-shadow n-border-color">
        <div className="draggable-box n-no-shadow n-flat">
            <h1>1</h1>
        </div>
        <div className="draggable-box n-no-shadow n-flat">
            <h1>2</h1>
        </div>
    </div>
    <div className="droppable-area n-no-shadow n-border-color"></div>
</div>`,
css: `.drag-container {  
    display: flex;
    flex-wrap: wrap;
    height: 250px;  
    position: relative;
}
.drag-container > .droppable-area {
    flex: 1 1;
    width: 100%; 
    border: 2px dashed #fff;
    border-radius: 15px;
    padding: 15px;
    transition: box-shadow 300ms ease-in;
}
.drag-container > .droppable-area + .droppable-area {
    margin-left: 15px
}
.drag-container .draggable-box {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 50px;
    min-height: 50px;
    padding: 0 10px; 
    border-radius: 10px;
    transition: box-shadow 300ms ease-in;
    cursor: grab;
}
.drag-container .draggable-box[hidden] {
    display: none !important;
}
.drag-container .draggable-box > h1 { 
    margin-bottom: 5px;
}
.drag-container .droppable-area > .draggable-box:not(:last-child) {
    margin-right: 5px;
}
.drag-container .grabbed {
    cursor: grabbing;
    margin: 0;
}`,
js: `const dragger = new Dragger('#drag-droppable', {
    draggable: '.draggable-box',
    droppable: '.droppable-area',
})
dragger.on('dragstart', (e) => {
    const target = e.target
    if(e.isDraggableElement) {
        e.preventDefault() 
        target.classList.add('grabbed')
        target.classList.add('n-float')
        target.classList.remove('n-flat')
    }
   
})
dragger.on('dragend', (e) => {
    const target = e.target
    if(e.isDraggableElement) { 
        /*async it to show transition*/
        setTimeout(() => {
            target.classList.add('n-flat')
            target.classList.remove('n-float')
            target.classList.remove('grabbed')
        },0)
    }
})
dragger.on('dragenter', (e) => {
    if(e.isDraggableElement && e.target.parentElement !== e.currentDroppable) { 
        e.currentDroppable.classList.add('n-engrave') 
    }
})
dragger.on('dragexit', (e) => {
    if(e.isDraggableElement && e.target.parentElement !== e.currentDroppable) { 
        e.currentDroppable.classList.remove('n-engrave') 
    }
})
dragger.on('drop', (e) => {
    if(e.isDraggableElement) {
        if(e.target.parentElement !== e.currentDroppable)
            e.currentDroppable.appendChild(e.target) 
        e.currentDroppable.classList.remove('n-engrave') 
    }
})`
}

export const Cloning = {
html: `<div id="drag-cloning" className="drag-container">  
    <div className="droppable-area n-no-shadow n-border-color">
        <div className="draggable-box n-no-shadow n-flat" id="draggable-1">
            <h1>1</h1>
        </div>
        <div className="draggable-box n-no-shadow n-flat" id="draggable-2">
            <h1>2</h1>
        </div> 
    </div>
    <div className="droppable-area n-no-shadow n-border-color">
        <div className="draggable-box n-no-shadow n-flat" id="draggable-3">
            <h1>3</h1>
        </div>
        <div className="draggable-box n-no-shadow n-flat" id="draggable-4">
            <h1>4</h1>
        </div>
    </div>
</div>`,
css: `.drag-container {  
    display: flex;
    flex-wrap: wrap;
    height: 250px;  
    position: relative;
}
.drag-container > .droppable-area {
    flex: 1 1;
    width: 100%; 
    border: 2px dashed #fff;
    border-radius: 15px;
    padding: 15px;
    transition: box-shadow 300ms ease-in;
}
.drag-container > .droppable-area + .droppable-area {
    margin-left: 15px
}
.drag-container .draggable-box {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 50px;
    min-height: 50px;
    padding: 0 10px; 
    border-radius: 10px;
    transition: box-shadow 300ms ease-in;
    cursor: grab;
}
.drag-container .draggable-box[hidden] {
    display: none !important;
}
.drag-container .drag-clone > h1 {
    visibility: hidden;
}
.drag-container .draggable-box > h1 { 
    margin-bottom: 5px;
}
.drag-container .droppable-area > .draggable-box:not(:last-child) {
    margin-right: 5px;
}
.drag-container .grabbed {
    cursor: grabbing;
    margin: 0;
}`,
js: `        let clone
const cloningAlgorithm = (e, elementToInsert) => {
    const droppable = e.droppable && e.droppable.closest('.draggable-box')
    const currentDroppable = e.currentDroppable 
    /*prevent cloning in the same droppable-area*/
    if(e.target.closest('.droppable-area') === currentDroppable) return;
    if(droppable && currentDroppable 
        && droppable !== elementToInsert 
        && droppable !== currentDroppable) {
        const droppableRect = droppable.getBoundingClientRect()
        /*the clone positioning is base on x axis*/
        const isBefore = e.clientX - droppableRect.left < droppableRect.width/2
        const next = droppable.nextElementSibling
        if(!next && !isBefore) {
            currentDroppable.appendChild(elementToInsert)
        }
        currentDroppable.insertBefore(elementToInsert, isBefore ? droppable : next )
    } else if(currentDroppable && e.droppable === currentDroppable){
        currentDroppable.appendChild(elementToInsert)
    }
}

const dragger = new Dragger('#drag-cloning', {
    draggable: '.draggable-box',
    droppable: '.droppable-area',
})
dragger.on('dragstart', (e) => {
    const target = e.target
    if(e.isDraggableElement) {
        e.preventDefault() 
        clone = target.cloneNode(true)
        clone.classList.add('drag-clone')
        target.classList.add('grabbed')
        target.classList.add('n-float')
        target.classList.remove('n-flat') 
        
    }
   
})
dragger.on('dragover', (e) => { 
    cloningAlgorithm(e, clone)
}) 
dragger.on('dragenter', (e) => {
    if(e.isDraggableElement && e.target.parentElement !== e.currentDroppable) { 
        e.currentDroppable.classList.add('n-engrave') 
    } 
})
dragger.on('dragexit', (e) => {
    if(e.isDraggableElement && e.target.parentElement !== e.currentDroppable) { 
        e.currentDroppable.classList.remove('n-engrave') 
    }
    /*remove clone when exiting*/
    e.currentDroppable.contains(clone) && clone.remove()
})
dragger.on('drop', (e) => {
    if(e.isDraggableElement) { 
        cloningAlgorithm(e, e.target) 
        e.currentDroppable.classList.remove('n-engrave') 
    } 
})
dragger.on('dragend', (e) => {
    const target = e.target
    if(e.isDraggableElement) { 
        clone && clone.remove()
        /*async it to show transition*/
        setTimeout(() => {
            target.classList.add('n-flat')
            target.classList.remove('n-float')
            target.classList.remove('grabbed')
        },0)
    }
})`
}

export const Switching = {
html: `<ul className="switching-area">
    <li className="switching-box n-no-shadow n-flat-low" data-index="1">
        <h5>Apple</h5>
    </li>
    <li className="switching-box n-no-shadow n-flat-low" data-index="2">
        <h5>Peach</h5>
    </li> 
    <li className="switching-box n-no-shadow n-flat-low" data-index="3">
        <h5>Orange</h5>
    </li>
    <li className="switching-box n-no-shadow n-flat-low" data-index="4">
        <h5>Grapes</h5>
    </li>
    <li className="switching-box n-no-shadow n-flat-low" data-index="5">
        <h5>Banana</h5>
    </li>
</ul>`,
css: `.switching-area {
    display: block;
    position: relative;
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
}
.switching-area > .switching-box {
    display: flex;  
    align-items: center; 
    position: relative;
    width: 100%;
    min-height: 50px;
    padding: 0 10px; 
    border-radius: 7px;
    transition: box-shadow 300ms ease-in;
    cursor: grab;
}
.switching-area > .switching-box[hidden] {
    display: none !important;
}
.switching-area > .switching-box:not(.drag-clone):before {
    content: attr(data-index);
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
}
.switching-area > .switching-box:not(:last-child) {
    margin-bottom: 7px;
}
.switching-area > .drag-clone > *{
    visibility: hidden;
}
.switching-area .grabbed {
    cursor: grabbing;
    margin: 0;
    z-index: 1;
}`,
js: `let clone
const switchingAlgorithm = (e, elementToInsert) => {
    const droppable = e.droppable && e.droppable.closest('.switching-box')
    const currentDroppable = e.currentDroppable  
    if(droppable && currentDroppable 
        && droppable !== elementToInsert 
        && droppable !== currentDroppable) {

        const droppableRect = droppable.getBoundingClientRect()
        const isFirstChild = currentDroppable.firstElementChild === droppable
        const isLastChild = currentDroppable.lastElementChild === droppable
        const divident = isFirstChild ? 0 : isLastChild ? droppableRect.height : 2
        /*the clone positioning is base on y axis*/
        const isBefore = e.clientY - droppableRect.top < droppableRect.height/divident
        const next = droppable.nextElementSibling
        if(!next && !isBefore) {
            currentDroppable.appendChild(elementToInsert)
        }
        currentDroppable.insertBefore(elementToInsert, isBefore ? droppable : next )
    }
}

const dragger = new Dragger('.switching-area', {
    draggable: '.switching-box',
    droppable: '.switching-area',
    axis: 'y',
})

dragger.on('dragstart', (e) => {
    const target = e.target
    if(e.isDraggableElement) {
        e.preventDefault() 
        clone && clone.remove()
        clone = target.cloneNode(true)
        clone.classList.add('drag-clone')
        clone.classList.remove('n-flat-low')
        target.closest('.switching-area').insertBefore(clone, e.target )
        target.classList.add('grabbed')
        target.classList.add('n-float-low')
        target.classList.remove('n-flat-low')  
    }
   
})
dragger.on('dragover', (e) => { 
    switchingAlgorithm(e, clone)
})  
dragger.on('drop', (e) => {
    const target = e.target  
    if(e.isDraggableElement) {  
        switchingAlgorithm(e, target) 
    } 
})
dragger.on('dragend', (e) => {
    const target = e.target
    if(e.isDraggableElement) { 
        clone.remove()
        Array.from(e.container.children)
            .forEach((each, i) => each.dataset.index = i + 1)
        setTimeout(() => {
            target.classList.add('n-flat')
            target.classList.remove('n-float')
            target.classList.remove('grabbed')
        }, 0)
    }
})`
}